<div class="common-select" [ngClass]="view" [formGroup]="form">
  @if (context.label) {
    <div>
      <label for="{{ context.field }}" class="label mb-1 text-nowrap" [ngClass]="{ required: required }">
        {{ context.label | translate }}
        @if (required) {
          <span [class.color-error]="!useDefaultAsteriskColor">*</span>
        }
      </label>
      @if (context.tooltip) {
        <app-icon
          class="open-icon margin-left-sm mb-1"
          width="1rem"
          height="1rem"
          [appTooltip]="context.tooltip | translate"
          [attr.aria-label]="context.tooltip | translate"
          container="body"
          icon="question-mark-2"
        >
        </app-icon>
      }
    </div>
  }

  @if (context.description) {
    <span class="mb-1">
      {{ context.description | translate }}
    </span>
  }
  <select
    (change)="onSelectChange()"
    [attr.disabled]="disabled ? true : null"
    [attr.aria-required]="required"
    [class.w-100]="fullWidthInput"
    [compareWith]="comparator()"
    [formControlName]="context.field"
    [attr.aria-describedby]="context.field + '-error'"
    [attr.aria-invalid]="form | fieldInvalid: context.field"
    id="{{ context.field }}"
  >
    @if (context.placeholderValue) {
      <option [ngValue]="null" disabled>
        {{ context.placeholderValue | translate }}
      </option>
    }
    @for (value of selectValues; track $index) {
      <option [ngValue]="context.valueKey ? value[context.valueKey] : value">
        @if (context.translateName) {
          {{ getOptionName(value) | translate }}
        }
        @if (!context.translateName) {
          {{ getOptionName(value) }}
        }
      </option>
    }
  </select>
  @if (form) {
    <div [id]="context.field + '-error'" class="error-container">
      <app-form-field-error
        [formValidationRequest$]="formValidationRequest$"
        [field]="form.get(context.field)"
        [name]="context.field"
        [label]="context.label"
        [customMessage]="context.customMessage"
      ></app-form-field-error>
    </div>
  }
</div>
